import React from 'react';

import {SvgProps} from '../../helpers/type';

const Smile = ({className}: SvgProps): JSX.Element => {
    return (
        <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M18.7231 9.86169C18.7231 10.6774 18.0618 11.3386 17.2461 11.3386C16.4305 11.3386 15.7692 10.6774 15.7692 9.86169C15.7692 9.04601 16.4305 8.38477 17.2461 8.38477C18.0618 8.38477 18.7231 9.04601 18.7231 9.86169Z"
                fill="#174943"
            />
            <path
                d="M10.4154 9.86169C10.4154 10.6774 9.75414 11.3386 8.93846 11.3386C8.12277 11.3386 7.46153 10.6774 7.46153 9.86169C7.46153 9.04601 8.12277 8.38477 8.93846 8.38477C9.75414 8.38477 10.4154 9.04601 10.4154 9.86169Z"
                fill="#174943"
            />
            <path
                d="M8.38462 15.7692C9.30589 17.4247 11.0278 18.5385 13 18.5385C14.9722 18.5385 16.6941 17.4247 17.6154 15.7692M25 13C25 19.6274 19.6274 25 13 25C6.37258 25 1 19.6274 1 13C1 6.37258 6.37258 1 13 1C19.6274 1 25 6.37258 25 13Z"
                stroke="#174943"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default Smile;
